module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('Header', {
    staticClass: "black"
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "pagebg",
    style: ({
      backgroundImage: 'url(' + _vm.newbg + ')'
    })
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.isme) ? _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.modal = true
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" 换背景")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "auth-box"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.produceInfo) ? _c('div', {
    staticClass: "master-info clearfix"
  }, [_c('div', {
    staticClass: "master-mask l"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.produceInfo.faceUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "master-vitae r"
  }, [_c('div', {
    staticClass: "vitae-head clearfix"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.produceInfo.nickName))]), _vm._v(" "), _c('ul', {
    staticClass: "tag clearfix"
  }, [(_vm.produceInfo.tagStatus == 3 || _vm.produceInfo.isProducer == 1) ? _c('li', [(_vm.produceInfo.tagStatus == 3) ? _c('i', {
    staticClass: "pro_tag"
  }) : _vm._e(), _vm._v(" "), (_vm.produceInfo.isProducer == 1) ? _c('i', {
    staticClass: "pro_auth"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.produceInfo.producerType == 2 && _vm.produceInfo.isProducer == 1) ? _c('li', [_c('span', [_vm._v("团队")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("teamSize")(_vm.produceInfo.teamSize)))])]) : _vm._e(), _vm._v(" "), (_vm.produceInfo.producerType == 1 && _vm.produceInfo.isProducer == 1) ? _c('li', {
    staticClass: "personal"
  }, [_c('span', [_vm._v("个人")]), _vm._v(" "), (_vm.produceInfo.gender == 1) ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.produceInfo.gender == 2) ? _c('span', [_vm._v("女")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.isme) ? _c('div', {
    staticClass: "buttons r",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.produceInfo.tagStatus == 0) ? _c('button', {
    staticClass: "btn btn-empty",
    on: {
      "click": function($event) {
        return _vm.onTagReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("标签认证")]) : _vm._e(), _vm._v(" "), (_vm.produceInfo.tagStatus == 1) ? _c('button', {
    staticClass: "btn btn-empty border-blue",
    on: {
      "click": function($event) {
        return _vm.onTagReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon shenhe2"
  }), _vm._v("认证中")]) : _vm._e(), _vm._v(" "), (_vm.produceInfo.tagStatus == 2) ? _c('button', {
    staticClass: "btn btn-empty border-red",
    on: {
      "click": function($event) {
        return _vm.onTagReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon shenhe2"
  }), _vm._v("认证失败")]) : _vm._e(), _vm._v(" "), (_vm.produceInfo.tagStatus == 3) ? _c('button', {
    staticClass: "btn btn-empty bg-blue",
    on: {
      "click": function($event) {
        return _vm.onTagReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon shenhe2"
  }), _vm._v("认证标签")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.isProducer == 0) ? _c('button', {
    staticClass: "btn btn-empty",
    on: {
      "click": function($event) {
        return _vm.onProducerReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("制作人认证")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.isProducer == 1) ? _c('button', {
    staticClass: "btn bg-yellow",
    on: {
      "click": function($event) {
        return _vm.onProducerReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("已认证")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.isProducer == 2) ? _c('button', {
    staticClass: "btn bg-orange",
    on: {
      "click": function($event) {
        return _vm.onProducerReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("认证审核中")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.isProducer == 3) ? _c('button', {
    staticClass: "btn bg-red",
    on: {
      "click": function($event) {
        return _vm.onProducerReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("认证失败")]) : _vm._e(), _vm._v(" "), (_vm.produceAuthMsg) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "bottom": "-35px",
      "width": "200px",
      "color": "#FF4C4C"
    }
  }, [_vm._v("*未满3个月不可以重新进行认证")]) : _vm._e()]) : _c('div', {
    staticClass: "keep"
  }, [(!_vm.produceInfo.isKeep) ? _c('button', {
    staticClass: "btn btn-empty btn-collect r",
    on: {
      "click": _vm.onKeep
    }
  }, [_c('i'), _vm._v("收藏")]) : _vm._e(), _vm._v(" "), (_vm.produceInfo.isKeep) ? _c('button', {
    staticClass: "btn btn-empty btn-collect r ed",
    on: {
      "click": _vm.onKeep
    }
  }, [_c('i'), _vm._v("已收藏")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "vitae-tag"
  }, [_c('span', [_vm._v(_vm._s(_vm.produceInfo.tagStr))])]), _vm._v(" "), _c('div', {
    staticClass: "vitae-foot"
  }, [_c('div', [_c('label', [_vm._v("所在城市")]), _vm._v(_vm._s(_vm.produceInfo.city && _vm.produceInfo.isProducer == 1 ? _vm.produceInfo.city : "尚未编辑") + "\n                "), _c('label', [_vm._v("从业年份")]), _vm._v(_vm._s(_vm.produceInfo.joinDate && _vm.produceInfo.isProducer == 1 ? _vm.produceInfo.joinDate : "尚未编辑") + "\n              ")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("擅长类型")]), _vm._v(_vm._s(_vm.produceInfo.skillStr && _vm.produceInfo.isProducer == 1 ? _vm.produceInfo.skillStr : "尚未编辑") + "\n              ")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("职业角色")]), _vm._v(_vm._s(_vm.produceInfo.roleStr && _vm.produceInfo.isProducer == 1 ? _vm.produceInfo.roleStr : "尚未编辑") + "\n              ")]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.produceInfo.summary && _vm.produceInfo.isProducer == 1 ? _vm.produceInfo.summary : "此人很懒，暂无相关介绍~"))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabsbar clearfix"
  }, [_c('div', {
    staticClass: "tabs l"
  }, [_c('span', {
    staticClass: "tab",
    class: {
      on: _vm.currTab == 1
    },
    on: {
      "click": function($event) {
        return _vm.onTabPanel(1)
      }
    }
  }, [_vm._v("作品集")]), _vm._v(" "), _c('span', {
    staticClass: "tab",
    class: {
      on: _vm.currTab == 2
    },
    on: {
      "click": function($event) {
        return _vm.onTabPanel(2)
      }
    }
  }, [_vm._v("场地库")]), _vm._v(" "), _c('span', {
    staticClass: "tab",
    class: {
      on: _vm.currTab == 3
    },
    on: {
      "click": function($event) {
        return _vm.onTabPanel(3)
      }
    }
  }, [_vm._v("器材库")]), _vm._v(" "), (_vm.isme) ? _c('span', {
    staticClass: "tab",
    class: {
      on: _vm.currTab == 4
    },
    on: {
      "click": function($event) {
        return _vm.onTabPanel(4)
      }
    }
  }, [_vm._v("认证信息")]) : _vm._e(), _vm._v(" "), (_vm.isme && _vm.userInfo.isProducer == 1) ? _c('span', {
    staticClass: "tab",
    class: {
      on: _vm.currTab == 5
    },
    on: {
      "click": function($event) {
        return _vm.onTabPanel(5)
      }
    }
  }, [_vm._v("服务协议")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab < 4),
      expression: "currTab < 4"
    }],
    staticClass: "opera r"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchVal),
      expression: "searchVal"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.searchText,
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.searchVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchVal = $event.target.value
      }
    }
  }), _c('a', {
    on: {
      "click": _vm.onSearch
    }
  })]), _vm._v(" "), (_vm.isme && _vm.currTab == 1) ? _c('button', {
    staticClass: "btn btn-default pub",
    on: {
      "click": function($event) {
        return _vm.toPublish()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("发布作品")]) : _vm._e(), _vm._v(" "), (_vm.isme && _vm.currTab == 2) ? _c('button', {
    staticClass: "btn btn-default pub",
    on: {
      "click": function($event) {
        return _vm.toPublishVenue()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("发布场地")]) : _vm._e(), _vm._v(" "), (_vm.isme && _vm.currTab == 3) ? _c('button', {
    staticClass: "btn btn-default pub",
    on: {
      "click": function($event) {
        return _vm.toPublishEquipment()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("发布器材")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-panel"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaultPanel.panel5),
      expression: "defaultPanel.panel5"
    }],
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/546.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有搜索到相关内容，换个关键词试试")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaultPanel.panel1 && _vm.currTab == 1 && !_vm.defaultPanel.panel5),
      expression: "defaultPanel.panel1 && currTab == 1 && !defaultPanel.panel5"
    }],
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/547.png")
    }
  }), _vm._v(" "), (!_vm.isme) ? _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("这个人太低调了，还没有发布作品")]), _vm._v(" "), _c('p', [_vm._v("去看看其他内容吧～")])]) : _vm._e(), _vm._v(" "), (_vm.isme) ? _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("您还没有上传作品哦～")]), _vm._v(" "), _c('p', [_vm._v("你若您有作品可用于展示，可发布作品，提升接单率")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaultPanel.panel2 && _vm.currTab == 2 && !_vm.defaultPanel.panel5),
      expression: "defaultPanel.panel2 && currTab == 2 && !defaultPanel.panel5"
    }],
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/543.png")
    }
  }), _vm._v(" "), (!_vm.isme) ? _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("这个人太低调了，还没有发布场地")]), _vm._v(" "), _c('p', [_vm._v("去看看其他内容吧～")])]) : _vm._e(), _vm._v(" "), (_vm.isme) ? _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("您还没有发布场地信息哦～")]), _vm._v(" "), _c('p', [_vm._v("若您有场地可用于出租，可发布场地，若拍摄有租用需求会与您联系")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaultPanel.panel3 && _vm.currTab == 3 && !_vm.defaultPanel.panel5),
      expression: "defaultPanel.panel3 && currTab == 3 && !defaultPanel.panel5"
    }],
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/544.png")
    }
  }), _vm._v(" "), (!_vm.isme) ? _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("这个人太低调了，还没有发布器材")]), _vm._v(" "), _c('p', [_vm._v("去看看其他内容吧～")])]) : _vm._e(), _vm._v(" "), (_vm.isme) ? _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("您还没有发布器材信息哦～")]), _vm._v(" "), _c('p', [_vm._v("若您有器材可用于出租，可发布器材，若拍摄有租用需求会与您联系")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaultPanel.panel4 && _vm.currTab == 4),
      expression: "defaultPanel.panel4 && currTab == 4"
    }],
    staticClass: "toauth"
  }, [_c('div', {
    staticClass: "toauth-producer"
  }, [_c('p', [_vm._v("您还未进行制作人资质认证，认证后可在平台展示作品及接单")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.onProducerReal()
      }
    }
  }, [_vm._v("请前往认证")])])]), _vm._v(" "), _c('div', {
    staticClass: "toauth-tag"
  }, [_c('p', [_vm._v("您未进行制作人标签，如有需要可前往认证")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.onTagReal()
      }
    }
  }, [_vm._v("认证标签")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab == 1 && (_vm.produceList.length || this.topProduce)),
      expression: "currTab == 1 && (produceList.length || this.topProduce)"
    }],
    staticClass: "panel"
  }, [(this.topProduce) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.searchVal),
      expression: "!searchVal"
    }],
    staticClass: "topping clearfix"
  }, [_c('div', {
    staticClass: "img l"
  }, [_c('a', {
    attrs: {
      "href": 'caseDe.html?id=' + _vm.topProduce.id
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.topProduce.coverUrl
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "length"
  }, [_vm._v(_vm._s(_vm.topProduce.videoLength))])]), _vm._v(" "), _c('div', {
    staticClass: "info-box r"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "h2"
  }, [_vm._v(_vm._s(_vm.topProduce.title))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [(_vm.isme) ? _c('span', {
    staticClass: "ident"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("置顶作品")]) : _vm._e(), _vm._v("发布时间：" + _vm._s(_vm._f("formatDate")(_vm.topProduce.addTime)))]), _vm._v(" "), _c('ul', {
    staticClass: "tag clearfix"
  }, _vm._l((_vm.topProduce.typeStr), function(ys) {
    return _c('li', [_c('span', [_vm._v(_vm._s(ys))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.topProduce.description))])]), _vm._v(" "), (_vm.isme && _vm.topProduce.checkStatus != 0) ? _c('div', {
    staticClass: "opera"
  }, [_c('a', {
    staticClass: "edit",
    attrs: {
      "href": 'publication.html?edit=' + _vm.topProduce.id
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.del(_vm.topProduce)
      }
    }
  }, [_vm._v("删除")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list clearfix"
  }, _vm._l((_vm.produceList), function(item) {
    return _c('div', {
      staticClass: "case l"
    }, [_c('div', {
      staticClass: "imgbox"
    }, [_c('a', {
      attrs: {
        "href": 'caseDe.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.coverUrl
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "length"
    }, [_vm._v(_vm._s(item.videoLength))])]), _vm._v(" "), (item.checkStatus == 1) ? _c('div', {
      staticClass: "bg summary"
    }, [_c('p', [_vm._v(_vm._s(item.description))])]) : _vm._e()]), _vm._v(" "), (item.checkStatus != 1) ? _c('div', {
      staticClass: "bg state"
    }, [(item.checkStatus == 0) ? _c('p', {
      staticClass: "audit"
    }, [_c('i', {
      staticClass: "icon"
    }), _vm._v("审核中")]) : _vm._e(), _vm._v(" "), (item.checkStatus == 2) ? _c('p', {
      staticClass: "fail"
    }, [_c('i', {
      staticClass: "icon"
    }), _vm._v("审核失败")]) : _vm._e(), _vm._v(" "), (item.checkStatus == 2) ? _c('p', {
      staticStyle: {
        "padding": "0 35px",
        "margin-top": "15px",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.checkMsg))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "info-box"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "h3"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('ul', {
      staticClass: "tag clearfix"
    }, _vm._l((item.typeStr), function(ys, index) {
      return (index < 3) ? _c('li', {
        staticClass: "l"
      }, [_c('span', [_vm._v(_vm._s(ys))])]) : _vm._e()
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(item.addTime)))]), _vm._v(" "), (_vm.isme && item.checkStatus != 0) ? _c('div', {
      staticClass: "opera r"
    }, [(item.checkStatus == 1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.getTop(item.id)
        }
      }
    }, [_vm._v("置顶")]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'publication.html?edit=' + item.id
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.del(item)
        }
      }
    }, [_vm._v("删除")])]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.totalPage / _vm.pageSize > 1) ? _c('div', {
    staticClass: "pages"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalPage,
      "page-size": _vm.pageSize,
      "current": _vm.currPage
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab == 2 && _vm.venueList.length),
      expression: "currTab == 2 && venueList.length"
    }]
  }, [_c('div', {
    staticClass: "list clearfix"
  }, _vm._l((_vm.venueList), function(item) {
    return _c('div', {
      staticClass: "case l"
    }, [_c('div', {
      staticClass: "imgbox"
    }, [_c('a', {
      attrs: {
        "href": 'venueDetails.html?id=' + item.id + '&type=1',
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.cover
      }
    })])]), _vm._v(" "), (item.checkStatus != 1) ? _c('div', {
      staticClass: "bg state"
    }, [(item.checkStatus == 0) ? _c('p', {
      staticClass: "audit"
    }, [_c('i', {
      staticClass: "icon"
    }), _vm._v("审核中")]) : _vm._e(), _vm._v(" "), (item.checkStatus == 2) ? _c('p', {
      staticClass: "fail"
    }, [_c('i', {
      staticClass: "icon"
    }), _vm._v("审核失败")]) : _vm._e(), _vm._v(" "), (item.checkStatus == 2) ? _c('p', {
      staticStyle: {
        "padding": "0 35px",
        "margin-top": "15px",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.checkMsg))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "info-box"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "h3"
    }, [_c('a', {
      attrs: {
        "href": 'venueDetails.html?id=' + item.id + '&type=1',
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "tag"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("venueLocal")(item.location)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.area) + "m²")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.typeStr))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.purposeStr))])])]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(item.addTime)))]), _vm._v(" "), (_vm.isme) ? _c('div', {
      staticClass: "opera r"
    }, [_c('a', {
      attrs: {
        "href": 'publishVenue.html?id=' + item.id
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.delVenue(item)
        }
      }
    }, [_vm._v("删除")])]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.totalPage / _vm.pageSize > 1) ? _c('div', {
    staticClass: "pages"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalPage,
      "page-size": _vm.pageSize,
      "current": _vm.currPage
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab == 3 && _vm.equipmentList.length),
      expression: "currTab == 3 && equipmentList.length"
    }]
  }, [_c('div', {
    staticClass: "list clearfix"
  }, _vm._l((_vm.equipmentList), function(item) {
    return _c('div', {
      staticClass: "case l"
    }, [_c('div', {
      staticClass: "imgbox"
    }, [_c('a', {
      attrs: {
        "href": 'venueDetails.html?id=' + item.id + '&type=2',
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.cover
      }
    })])]), _vm._v(" "), (item.checkStatus != 1) ? _c('div', {
      staticClass: "bg state"
    }, [(item.checkStatus == 0) ? _c('p', {
      staticClass: "audit"
    }, [_c('i', {
      staticClass: "icon"
    }), _vm._v("审核中")]) : _vm._e(), _vm._v(" "), (item.checkStatus == 2) ? _c('p', {
      staticClass: "fail"
    }, [_c('i', {
      staticClass: "icon"
    }), _vm._v("审核失败")]) : _vm._e(), _vm._v(" "), (item.checkStatus == 2) ? _c('p', {
      staticStyle: {
        "padding": "0 35px",
        "margin-top": "15px",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.checkMsg))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "info-box"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "h3"
    }, [_c('a', {
      attrs: {
        "href": 'venueDetails.html?id=' + item.id + '&type=2',
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(item.addTime)))]), _vm._v(" "), (_vm.isme) ? _c('div', {
      staticClass: "opera r"
    }, [_c('a', {
      attrs: {
        "href": 'publishEquipment.html?id=' + item.id
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.delEquipment(item)
        }
      }
    }, [_vm._v("删除")])]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.totalPage / _vm.pageSize > 1) ? _c('div', {
    staticClass: "pages"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalPage,
      "page-size": _vm.pageSize,
      "current": _vm.currPage
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab == 4 && _vm.userInfo.isProducer),
      expression: "currTab == 4 && userInfo.isProducer"
    }]
  }, [_c('div', {
    staticClass: "pane-accinfo"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('span', [_vm._v("制作人资质认证")]), _vm._v(" "), (_vm.isme) ? _c('div', {
    staticClass: "buttons r",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.userInfo.isProducer == 0) ? _c('button', {
    staticClass: "btn btn-empty",
    on: {
      "click": function($event) {
        return _vm.onProducerReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("制作人认证")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.isProducer == 1) ? _c('button', {
    staticClass: "btn bg-yellow",
    on: {
      "click": function($event) {
        return _vm.onProducerReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("已认证")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.isProducer == 2) ? _c('button', {
    staticClass: "btn bg-orange",
    on: {
      "click": function($event) {
        return _vm.onProducerReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("认证审核中")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.isProducer == 3) ? _c('button', {
    staticClass: "btn bg-red",
    on: {
      "click": function($event) {
        return _vm.onProducerReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("认证失败")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cont clearfix"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("类型：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.authInfo.producerType == 1 ? '个人' : '团队'))])]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [(_vm.authInfo.producerType == 1) ? _c('span', [_vm._v("真实姓名：")]) : _vm._e(), _vm._v(" "), (_vm.authInfo.producerType == 2) ? _c('span', [_vm._v("公司名称：")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.authInfo.producerName))])]), _vm._v(" "), (_vm.authInfo.producerType == 1) ? _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("性别：")]), _vm._v(" "), (_vm.authInfo.gender == 0) ? _c('span', [_vm._v("其他")]) : _vm._e(), _vm._v(" "), (_vm.authInfo.gender == 1) ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.authInfo.gender == 2) ? _c('span', [_vm._v("女")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.authInfo.producerType == 2) ? _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("团队规模：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("teamSize")(_vm.authInfo.teamSize)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("所在城市：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.authInfo.city))])]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("职业角色：")]), _vm._v(" "), _c('span', _vm._l((_vm.authInfo.cacheRole), function(item) {
    return _c('div', [_c('span', [_vm._v(_vm._s(item.role))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.price),
        expression: "item.price"
      }]
    }, [_vm._v(_vm._s(item.price) + "/天")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("从业年份：")]), _c('span', [_vm._v(_vm._s(_vm.authInfo.joinDate) + "年")])]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("擅长业务：")]), _c('span', _vm._l((_vm.authInfo.cacheSkill), function(item) {
    return _c('span', [_vm._v(_vm._s(item) + "  ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("简介：")]), _c('span', [_vm._v(_vm._s(_vm.authInfo.summary))])]), _vm._v(" "), (_vm.authInfo.producerType == 2) ? _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("联系人姓名：")]), _c('span', [_vm._v(_vm._s(_vm.authInfo.contactPerson))])]) : _vm._e(), _vm._v(" "), (_vm.authInfo.producerType == 2) ? _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("联系人手机号：")]), _c('span', [_vm._v(_vm._s(_vm.authInfo.contactNo))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "head"
  }, [_c('span', [_vm._v("制作人标签认证")]), _vm._v(" "), (_vm.isme) ? _c('div', {
    staticClass: "buttons r",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.produceInfo.tagStatus == 0) ? _c('button', {
    staticClass: "btn btn-empty",
    on: {
      "click": function($event) {
        return _vm.onTagReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("标签认证")]) : _vm._e(), _vm._v(" "), (_vm.produceInfo.tagStatus == 1) ? _c('button', {
    staticClass: "btn btn-empty border-blue",
    on: {
      "click": function($event) {
        return _vm.onTagReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon shenhe2"
  }), _vm._v("认证中")]) : _vm._e(), _vm._v(" "), (_vm.produceInfo.tagStatus == 2) ? _c('button', {
    staticClass: "btn btn-empty border-red",
    on: {
      "click": function($event) {
        return _vm.onTagReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon shenhe2"
  }), _vm._v("认证失败")]) : _vm._e(), _vm._v(" "), (_vm.produceInfo.tagStatus == 3) ? _c('button', {
    staticClass: "btn btn-empty bg-blue",
    on: {
      "click": function($event) {
        return _vm.onTagReal()
      }
    }
  }, [_c('i', {
    staticClass: "icon shenhe2"
  }), _vm._v("认证标签")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cont clearfix"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("已认证标签：")]), _c('span', [_vm._v(_vm._s(_vm.produceInfo.tagStr))])]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_c('span', [_vm._v("待审核标签：")]), _c('span', _vm._l((_vm.tagList), function(item) {
    return (item.apply) ? _c('span', {
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab == 5),
      expression: "currTab == 5"
    }]
  }, [_c('div', {
    staticClass: "protocol"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "opera"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gmSignStatus == 0),
      expression: "gmSignStatus == 0"
    }],
    staticClass: "btn btn-empty"
  }, [_vm._v("未签署")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gmSignStatus == 1),
      expression: "gmSignStatus == 1"
    }],
    staticClass: "btn"
  }, [_vm._v("已签署")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gmSignStatus == 2),
      expression: "gmSignStatus == 2"
    }],
    staticClass: "btn btn-red"
  }, [_vm._v("已过期")])])])])])])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "更换背景",
      "width": "800"
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "60px 50px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "overflow": "hidden",
      "height": "115px",
      "line-height": "115px"
    },
    attrs: {
      "id": "bg"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.newbg
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%",
      "color": "#ffffff",
      "font-size": "16px",
      "background": "rgba(0,0,0,.4)"
    }
  }, [_c('span', {}, [_vm._v("上传背景图")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20px",
      "color": "#B8B8B8",
      "font-size": "12px"
    }
  }, [_vm._v("请上传格式为jpg、jpeg、png的文件，大小不超过3M。建议尺寸1920*320px、960*160px。")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "30px 0",
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "150px",
      "height": "40px",
      "font-size": "16px",
      "color": "#ffffff"
    },
    attrs: {
      "long": "",
      "loading": _vm.modal_loading
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    staticClass: "model",
    attrs: {
      "title": "提示",
      "width": "480",
      "footer-hide": ""
    },
    model: {
      value: (_vm.ModalDelete.state),
      callback: function($$v) {
        _vm.$set(_vm.ModalDelete, "state", $$v)
      },
      expression: "ModalDelete.state"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "30px",
      "font-size": "18px",
      "text-align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ModalDelete.curr == 1),
      expression: "ModalDelete.curr == 1"
    }],
    staticStyle: {
      "margin-top": "38px"
    }
  }, [_vm._v("确定删除当前作品吗？")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ModalDelete.curr == 2),
      expression: "ModalDelete.curr == 2"
    }],
    staticStyle: {
      "margin-top": "38px"
    }
  }, [_vm._v("确定删除当前场地吗？")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ModalDelete.curr == 3),
      expression: "ModalDelete.curr == 3"
    }],
    staticStyle: {
      "margin-top": "38px"
    }
  }, [_vm._v("确定删除当前器材吗？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('Button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.ModalDeleteBtn()
      }
    }
  }, [_vm._v("确定")])], 1)])]), _vm._v(" "), _c('Modal', {
    staticClass: "model modal-tagreal",
    attrs: {
      "title": "身份标签认证",
      "width": "590",
      "footer-hide": ""
    },
    model: {
      value: (_vm.ModalTag),
      callback: function($$v) {
        _vm.ModalTag = $$v
      },
      expression: "ModalTag"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "4px",
      "font-size": "14px"
    }
  }, [_c('div', [_c('dl', {
    staticClass: "clearfix"
  }, [_c('dt', [_vm._v("选择标签")]), _vm._v(" "), _c('dd', {
    staticClass: "sel"
  }, _vm._l((_vm.tagList), function(item) {
    return _c('span', {
      staticClass: "btn btn-empty",
      class: {
        'active': item.apply, 'on': item.current
      },
      on: {
        "click": function($event) {
          return _vm.onTagSel(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('dl', {
    staticClass: "clearfix"
  }, [_c('dt', [_vm._v("证明文件")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "upl",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-empty",
    attrs: {
      "id": "tag"
    }
  }, [_vm._v("上传文件")])]), _vm._v(" "), _c('div', _vm._l((_vm.tagFileList), function(file, index) {
    return _c('div', {
      staticClass: "file"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/images/va.png")
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "name",
      attrs: {
        "href": file,
        "target": "_blank"
      }
    }, [_c('span', [_vm._v("证明文件" + _vm._s(index + 1))])]), _vm._v(" "), _c('a', {
      staticClass: "r del",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onDelTag(index)
        }
      }
    }, [_vm._v("删除")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "50px 0 80px",
      "text-align": "center"
    }
  }, [_c('Button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "280px"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmitTagReal()
      }
    }
  }, [_vm._v("提交审核")])], 1)])]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_vm._v("在平台接单需签署相关服务协议，请扫描下方二维码前往签署，"), _c('br'), _vm._v("若您已签署，也可通过下方二维码进行查询。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrimg"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/qr3.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90200674","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/userPage/App.vue
// module id = 1299
// module chunks = 12